import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,RouterLinkActive } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';

import { UserService } from './../user.service';
import { environment } from 'src/environments/environment';
import { from } from 'rxjs';
import { reject } from 'q';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {
  userForgotPasswordForm : FormGroup;
  Userlogin: any;
  Userloginmodel: any;
  UserloginService: any;
  constructor(private formBuilder : FormBuilder,
    private router : Router,
    private route : ActivatedRoute,
    private service : UserService,
    private cookie: CookieService) { }

  ngOnInit() {

    this.userForgotPasswordForm = this.formBuilder.group({
      'email' : ['',[Validators.required,Validators.minLength(1),Validators.email]],
     
    });
  }
  sendotp(){
    // console.log(this.userLoginForm.controls);
      if(this.userForgotPasswordForm.valid)
      {
       
        
        this.service.Userforgotpassword(this.userForgotPasswordForm.value).subscribe((result) =>{
        
          if(result.body['error'] == 'false')
          {
          
  
            environment.swalalert('success',result.body['otp']).then(value => {
              if(value){

                localStorage.setItem('forgotemail',this.userForgotPasswordForm.value.email)
                this.router.navigate(['/userverifyotp'])
              }
            });
          }else {
            environment.swalalert('error',result.body['error_message']);
            }
          
        },
          (error) => {
            console.error(error);
            reject(error);
          }
        );
      }else{
        environment.swalalert('error','Validation Required');  
      }
    }
}
